import React, { Component } from 'react';
import { Modal, Radio, DatePicker, message } from 'antd';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class ExportModal extends Component {
    state = {
        params: {},
    }

    hide = () => {
        this.setState({ params: {} }, () => {
            this.props.changeVisible(false);
        });
    }

    handleSubmit = () => {
        const { params } = this.state;
        const { type, startDate, endDate } = params;
        if (type) {
            if (type == 'PERFORMANCE') {
                if (!startDate || !endDate) {
                    message.warning('请选择统计月份');
                    return;
                } else if (startDate && endDate) {
                    if (moment(startDate).valueOf() > moment(endDate).valueOf()) {
                        message.warning('统计月份开始时间不能大于结束时间');
                        return;
                    }
                }
            }
            const { searchParams, pagination } = this.props;
            const { areaParams = {} } = searchParams;
            const url = API_URL.home.exportPerformanceSupervisorUserScore;
            const exportParams = {
                ...searchParams,
                ...areaParams,
                ...params,
            };
            delete exportParams.areaParams;
            delete exportParams.hasCheckedArea;
            ExportUtil.export({...exportParams}, pagination, url);
        }
        this.hide();
    }

    handleRadioChange = (e, type) => {
        const { params } = this.state;
        params.type = type;
        delete params.startDate;
        delete params.endDate;
        this.setState({ params });
    }

    onMonthChange = (date, dateString, field) => {
        const { params } = this.state;
        params[field] = dateString;
        this.setState({ params });
    }

    render() {
        const {
            params: {
                type,
                startDate,
                endDate,
            }
        } = this.state;
        const radioStyle = {
            display: 'block',
            height: '30px',
            marginLeft: '20px',
            lineHeight: '30px',
        };
        const { visible } = this.props;
        const newStartDate = startDate ? moment(startDate) : null;
        const newEndDate = endDate ? moment(endDate) : null;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                width="450px"
            >
                <div>
                    <p>请选择导出内容：</p>
                    <Radio style={radioStyle} checked={type == 'LIST'} onChange={e => this.handleRadioChange(e, 'LIST')}>人员主管绩效排行列表</Radio>
                    <Radio style={radioStyle} checked={type == 'LIST_CONTAIN_DETAIL'}  onChange={e => this.handleRadioChange(e, 'LIST_CONTAIN_DETAIL')}>人员主管绩效排行列表（含考核明细项得分）</Radio>
                    <Radio style={radioStyle} checked={type == 'DETAIL'}  onChange={e => this.handleRadioChange(e, 'DETAIL')}>人员主管绩效考核项数据明细</Radio>
                    <Radio style={radioStyle} checked={type == 'PERFORMANCE'}  onChange={e => this.handleRadioChange(e, 'PERFORMANCE')}>人员主管绩效分</Radio>
                    {
                        type == 'PERFORMANCE' &&
                        <div style={{marginLeft:43}}>
                            <span style={{marginRight: 15}}>统计月份</span>
                            <MonthPicker
                                value={newStartDate}
                                format={monthFormat}
                                placeholder="请选择"
                                style={{width: 120, verticalAlign: 'middle'}}
                                onChange={(date, dateString) => this.onMonthChange(date, dateString, 'startDate')}
                            />
                            <span style={{ marginLeft: 10, marginRight: 10 }}>~</span>
                            <MonthPicker
                                value={newEndDate}
                                format={monthFormat}
                                placeholder="请选择"
                                style={{width: 120, verticalAlign: 'middle'}}
                                onChange={(date, dateString) => this.onMonthChange(date, dateString, 'endDate')}
                            />
                        </div>
                    }
                </div>
            </Modal>

        );
    }
}

export default ExportModal;



// WEBPACK FOOTER //
// ./src/components/home/leaderPerformanceRank/ExportModal.js